/* ============
 * Bootstrap File
 * ============
 *
 * Will configure and bootstrap the application
 */

/* ============
 * Vue
 * ============
 *
 * Vue.js is a library for building interactive web interfaces.
 * It provides data-reactive components with a simple and flexible API.
 *
 * http://rc.vuejs.org/guide/
 */
import Vue from 'vue'

Vue.config.debug = process.env.NODE_ENV !== 'production'

/* ============
 * Vue Resource
 * ============
 *
 * Vue Resource provides services for making web requests and handle
 * responses using a XMLHttpRequest or JSONP.
 *
 * https://github.com/vuejs/vue-resource/tree/master/docs
 */
import VueResource from 'vue-resource'

Vue.use(VueResource)

Vue.http.headers.common.Accept = 'application/json'
Vue.http.options.root = process.env.API_LOCATION
Vue.http.interceptors.push((request, next) => {
  if (!request.url.startsWith(process.env.PPDB_API_LOCATION)) {
    request.headers.set('Authorization', 'Bearer ' + process.env.BYNDER_KEY);
  }

  next(() => {
  })
})

/* ============
 * Vue Resource NProgress
 * ============
 *
 * Interceps vue-resource request to show a progress bar
 *
 * https://github.com/imcvampire/vue-resource-nprogress
 */

import NProgress from 'nprogress'
window.NProgress = NProgress

import VueResourceNProgress from 'vue-resource-nprogress'
Vue.use(VueResourceNProgress)

/* ============
 * Vuex Router Sync
 * ============
 *
 * Effortlessly keep vue-Router and vuex store in sync.
 *
 * https://github.com/vuejs/vuex-router-sync/blob/master/README.md
 */
import VuexRouterSync from 'vuex-router-sync'
import store from './app/store'

/* ============
 * Vue Router
 * ============
 *
 * The official Router for Vue.js. It deeply integrates with Vue.js core
 * to make building Single Page Applications with Vue.js a breeze.
 *
 * http://router.vuejs.org/en/index.html
 */
import VueRouter from 'vue-router'
import routes from './app/routes'

Vue.use(VueRouter)

export const router = new VueRouter({
  mode: 'history',
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  },
  routes,
})

let backHomeWhenInactive = () => {
  let timeoutBackHome
  window.onload = resetTimer
  document.onclick = resetTimer
  document.onkeypress = resetTimer

  function backHome () {
    // router.push({
    //   name: 'home.index',
    //   replace: true,
    // })
    window.location = '/'
  }

  function resetTimer () {
    clearTimeout(timeoutBackHome)
    let minute = 1000 * 60
    timeoutBackHome = setTimeout(backHome, 5 * minute)
  }
}
backHomeWhenInactive()

VuexRouterSync.sync(store, router)

Vue.router = router

/* ============
 * jQuery
 * ============
 *
 * Require jQuery
 *
 * http://jquery.com/
 */
import jQuery from 'jquery'

window.$ = window.jQuery = jQuery

/* ============
 * Font Awesome
 * ============
 *
 * Require font-awesome
 *
 * http://http://fontawesome.io/
 */
require('font-awesome/less/font-awesome.less')

var WebFont = require('webfontloader')

WebFont.load({
  google: {
    families: ['Lato', 'Lato:300', 'Lato:300i', 'Lato:700'],
  },
})

/* ============
 * Styling
 * ============
 *
 */
require('../static/css/main.css')


export default {
  router,
}
